import React from "react";
import { Logo } from "../Logo";

export const LandingFooter = () => (
  <footer className="border-t border-[#052F24]/10 py-12">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-6">
      <Logo />
      <p className="text-xs text-[#052F24]/45 text-center max-w-xl font-light">
        Growth Funds · growthfunds.co.uk · Growth Funds is a credit broker, not a lender. Funding subject to status and lender approval.
      </p>
      <a href="/admin/login" className="text-xs font-semibold text-[#052F24]/50 hover:text-[#052F24] transition-colors" data-testid="admin-link">
        Team login
      </a>
    </div>
  </footer>
);
